import { render, staticRenderFns } from "./ChangeResponsible.vue?vue&type=template&id=208cfd78"
import script from "./ChangeResponsible.vue?vue&type=script&lang=js"
export * from "./ChangeResponsible.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports